// Record player SVG template used by login and progress screens.

const RECORD_PLAYER_STROKE_WIDTH = 1
const RECORD_PLAYER_STROKE_COLOR = '#9E9E9E'
const RECORD_PLAYER_SECONDARY_STROKE_COLOR = 'rgba(158,158,158,0.3)'
const RECORD_PLAYER_MARK_STROKE_COLOR = '#7A7A7A'
const RECORD_ROTATION_DURATION = '1.818s'

export default function recordPlayerTemplate(): string {
	const recordSpinStyle = `animation: spin ${RECORD_ROTATION_DURATION} linear infinite;`
	const recordMarkStyle = `transform-origin: 125px 125px; ${recordSpinStyle}`

	return `
        <svg
            id="record-player"
            viewBox="0 0 360 300"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
        >
            <defs>
                <linearGradient id="armbar-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="46%"  stop-color="transparent"/>
                    <stop offset="46%"  stop-color="${RECORD_PLAYER_STROKE_COLOR}"/>
                </linearGradient>
                <linearGradient id="armbartip-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="49%"  stop-color="transparent"/>
                    <stop offset="49%"  stop-color="${RECORD_PLAYER_STROKE_COLOR}"/>
                </linearGradient>
            </defs>
            <rect
                id="outerframe"
                x="1" y="1"
                width="358" height="298"
                rx="30" ry="30"
                fill="none"
                stroke="${RECORD_PLAYER_SECONDARY_STROKE_COLOR}"
                stroke-width="${RECORD_PLAYER_STROKE_WIDTH}"
            />
            <g id="recordholder" transform="translate(24,24)">
                <ellipse
                    id="record"
                    cx="125" cy="125" ry="122" rx="122.5"
                    stroke="${RECORD_PLAYER_STROKE_COLOR}"
                    stroke-width="${RECORD_PLAYER_STROKE_WIDTH}"
                    style="${recordSpinStyle}"
                />
                <circle
                    id="record-mark"
                    cx="125" cy="3.5" r="1.6"
                    fill="none"
                    stroke="${RECORD_PLAYER_MARK_STROKE_COLOR}"
                    stroke-width="1.2"
                    style="${recordMarkStyle}"
                />
                <circle
                    id="recordcenter"
                    cx="125" cy="125" r="40"
                    fill="${RECORD_PLAYER_STROKE_COLOR}"
                />
                <circle
                    id="center"
                    cx="125" cy="125" r="5"
                    fill="#000"
                />
            </g>
            <g id="armbase" transform="translate(280,24)">
                <circle
                    id="arm-hit-area"
                    cx="25" cy="25" r="90"
                    fill="transparent"
                    pointer-events="all"
                />
                <circle
                    id="pivotcircle"
                    cx="25" cy="25" r="25"
                    fill="none"
                    stroke="${RECORD_PLAYER_STROKE_COLOR}"
                    stroke-width="${RECORD_PLAYER_STROKE_WIDTH}"
                />
                <g id="innerarmbase" transform="translate(4,4)">
                    <rect
                        id="armbar"
                        x="16.5" y="-155"
                        width="8" height="310"
                        fill="url(#armbar-gradient)"
                    />
                    <!-- lower arm tip + needle, rotated around its center -->
                    <g transform="translate(16.5 79) rotate(25 4 75)">
                        <rect
                            id="armbarbottom"
                            x="0" y="0"
                            width="8" height="150"
                            fill="url(#armbartip-gradient)"
                        />
                        <rect
                            id="needle"
                            x="-1.5" y="130"
                            width="13" height="24"
                            rx="2" ry="2"
                        />
                    </g>
                </g>
            </g>
            <g id="controls">
                <circle
                    cx="290" cy="255" r="15"
                    fill="none" stroke="${RECORD_PLAYER_SECONDARY_STROKE_COLOR}" stroke-width="${RECORD_PLAYER_STROKE_WIDTH}"
                />
                <circle
                    cx="330" cy="255" r="15"
                    fill="none" stroke="${RECORD_PLAYER_SECONDARY_STROKE_COLOR}" stroke-width="${RECORD_PLAYER_STROKE_WIDTH}"
                />
            </g>
        </svg>
    `
}
